'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ModuleRoutes = exports.ModulePage = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  padding: 4px;\n\n  color: ', ';\n  border-bottom: 3px solid transparent;\n  font-weight: ', ';\n\n  text-decoration: none;\n\n  &:focus:not(:active) {\n    border-bottom: 3px solid ', ';\n    outline: none;\n  }\n'], ['\n  padding: 4px;\n\n  color: ', ';\n  border-bottom: 3px solid transparent;\n  font-weight: ', ';\n\n  text-decoration: none;\n\n  &:focus:not(:active) {\n    border-bottom: 3px solid ', ';\n    outline: none;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  padding-bottom: 8px;\n'], ['\n  padding-bottom: 8px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  overflow: hidden;\n\n  a {\n    text-overflow: ellipsis;\n  }\n'], ['\n  overflow: hidden;\n\n  a {\n    text-overflow: ellipsis;\n  }\n']);

var _path = require('path');

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactDocumentTitle = require('react-document-title');

var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);

var _reactRouterDom = require('react-router-dom');

var _Route = require('react-router/Route');

var _Route2 = _interopRequireDefault(_Route);

var _Switch = require('react-router/Switch');

var _Switch2 = _interopRequireDefault(_Switch);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('styled-material/dist/src/colors');

var _layout = require('styled-material/dist/src/layout');

var _urls = require('../../lib/urls');

var _classDetail = require('../docs/class-detail');

var _componentDetail = require('../docs/component-detail');

var _functionDetail = require('../docs/function-detail');

var _moduleDetail = require('../docs/module-detail');

var _typeDetail = require('../docs/type-detail');

var _variableDetail = require('../docs/variable-detail');

var _routerLink = require('../router-link');

var _sidenavLayout = require('../ui/sidenav-layout');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PathLink = (0, _styledComponents2.default)(_reactRouterDom.Link)(_templateObject, _colors.materialColors['indigo-500'], function (_ref) {
    var active = _ref.active;
    return active ? 500 : 400;
}, _colors.materialColors['pink-a400']);
var PathBar = _styledComponents2.default.div(_templateObject2);
var NavBlock = _styledComponents2.default.div(_templateObject3);
var ModulePage = exports.ModulePage = function ModulePage(_ref2) {
    var page = _ref2.page,
        appTitle = _ref2.appTitle,
        path = _ref2.path;
    return React.createElement(_layout.Column, null, React.createElement(_reactDocumentTitle2.default, { title: (page.apiDocs.title || _urls.defaultTitle) + ' - ' + appTitle }), React.createElement(PathBar, null, path.map(function (part, i) {
        return React.createElement("span", { key: i }, i > 0 && ' / ', React.createElement(_routerLink.RouterLink, { key: part.url, component: PathLink, exact: true, to: part.url }, part.module.name));
    })), React.createElement(_sidenavLayout.Container, null, React.createElement(_sidenavLayout.Nav, null, page.modules.length > 0 && React.createElement(NavBlock, null, React.createElement("h3", null, "Modules"), page.modules.map(function (module) {
        return React.createElement(_routerLink.RouterLink, { key: module.url, component: _sidenavLayout.NavLink, exact: true, to: module.url }, module.title);
    })), page.components.length > 0 && React.createElement(NavBlock, null, React.createElement("h3", null, "Components"), page.components.map(function (component) {
        return React.createElement(_routerLink.RouterLink, { key: component.name, component: _sidenavLayout.NavLink, exact: true, to: (0, _urls.entryUrl)(component, page.module, page.apiDocs) }, component.name);
    })), page.types.length > 0 && React.createElement(NavBlock, null, React.createElement("h3", null, "Types"), page.types.map(function (type) {
        return React.createElement(_routerLink.RouterLink, { key: type.name, component: _sidenavLayout.NavLink, exact: true, to: (0, _urls.entryUrl)(type, page.module, page.apiDocs) }, type.name);
    })), page.classes.length > 0 && React.createElement(NavBlock, null, React.createElement("h3", null, "Classes"), page.classes.map(function (type) {
        return React.createElement(_routerLink.RouterLink, { key: type.name, component: _sidenavLayout.NavLink, exact: true, to: (0, _urls.entryUrl)(type, page.module, page.apiDocs) }, type.name);
    })), page.functions.length > 0 && React.createElement(NavBlock, null, React.createElement("h3", null, "Functions"), page.functions.map(function (fn) {
        return React.createElement(_routerLink.RouterLink, { key: fn.name, component: _sidenavLayout.NavLink, exact: true, to: (0, _urls.entryUrl)(fn, page.module, page.apiDocs) }, fn.name);
    })), page.variables.length > 0 && React.createElement(NavBlock, null, React.createElement("h3", null, "Variables"), page.variables.map(function (variable) {
        return React.createElement(_routerLink.RouterLink, { key: variable.name, component: _sidenavLayout.NavLink, exact: true, to: (0, _urls.entryUrl)(variable, page.module, page.apiDocs) }, variable.name);
    }))), React.createElement(_sidenavLayout.Content, null, page.components.map(function (component) {
        return React.createElement(_Route2.default, { exact: true, key: component.name, path: (0, _urls.entryUrl)(component, page.module, page.apiDocs), render: function render() {
                return React.createElement(_componentDetail.ComponentDetail, { component: component, apiDocs: page.apiDocs });
            } });
    }), page.types.map(function (type) {
        return React.createElement(_Route2.default, { exact: true, key: type.name, path: (0, _urls.entryUrl)(type, page.module, page.apiDocs), render: function render() {
                return React.createElement(_typeDetail.TypeDetail, { type: type, apiDocs: page.apiDocs });
            } });
    }), page.classes.map(function (type) {
        return React.createElement(_Route2.default, { exact: true, key: type.name, path: (0, _urls.entryUrl)(type, page.module, page.apiDocs), render: function render() {
                return React.createElement(_classDetail.ClassDetail, { type: type, apiDocs: page.apiDocs });
            } });
    }), page.functions.map(function (fn) {
        return React.createElement(_Route2.default, { exact: true, key: fn.name, path: (0, _urls.entryUrl)(fn, page.module, page.apiDocs), render: function render() {
                return React.createElement(_functionDetail.FunctionDetail, { fn: fn, apiDocs: page.apiDocs });
            } });
    }), page.variables.map(function (variable) {
        return React.createElement(_Route2.default, { exact: true, key: variable.name, path: (0, _urls.entryUrl)(variable, page.module, page.apiDocs), render: function render() {
                return React.createElement(_variableDetail.VariableDetail, { variable: variable, apiDocs: page.apiDocs });
            } });
    }), React.createElement(_Route2.default, { exact: true, path: page.url, render: function render() {
            return React.createElement(_moduleDetail.ModuleDetail, { module: page.module, page: page });
        } }))));
};
var ModuleRoutes = exports.ModuleRoutes = function ModuleRoutes(_ref3) {
    var page = _ref3.page,
        appTitle = _ref3.appTitle,
        parent = _ref3.parent;
    return React.createElement(_Switch2.default, null, page.modules.map(function (module) {
        return React.createElement(_Route2.default, { key: module.url, path: module.url, render: function render() {
                return React.createElement(ModuleRoutes, { page: module, appTitle: appTitle, parent: parent ? [].concat(_toConsumableArray(parent), [page]) : [page] });
            } });
    }), React.createElement(_Route2.default, { exact: true, path: (0, _path.join)(page.url, '([a-z]+.[A-Za-z0-9_]+)?'), render: function render() {
            return React.createElement(ModulePage, { page: page, appTitle: appTitle, path: parent ? [].concat(_toConsumableArray(parent), [page]) : [page] });
        } }));
};
//# sourceMappingURL=module-page.js.map



// WEBPACK FOOTER //
// ../documittu/packages/template/dist/components/pages/module-page.js